<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div [hidden]="isCreate || isEdit || isParentDealerVerification">
      <div class="header-container">
        <h2>Parent Dealer</h2>
        <div class="search-and-filter-container">
          <div class="search-container">
            <input type="text" [formControl]="searchInput" placeholder="Search..." (input)="applyFilter()"
              class="form-control" />
            <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
          </div>
          <div class="status-filter-container">
            <select [formControl]="statusFilter" class="form-select status-select">
              <option value="All">All</option>
              <option value="1">New</option>
              <option value="2">Terminated</option>
              <option value="3">Multi Location</option>
            </select>
          </div>
        </div>

        <div class="button-container">
          <button mat-raised-button class="add-button mr-1" (click)="export()"> Export</button>
          <button mat-raised-button class="add-button mr-1" (click)="goToImport()"><img class="upload-img"
              src="/assets/images/upload.png" alt=""> Import</button>
          <button mat-raised-button class="add-button" (click)="add()">Add Parent Dealer</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>

          <ng-container matColumnDef="dealer_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Dealer Name</th>
            <td mat-cell *matCellDef="let element">{{element.dealer_name}}</td>
          </ng-container>

          <ng-container matColumnDef="dealer_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Dealer Code</th>
            <td mat-cell *matCellDef="let element">{{element.dealer_code}}</td>
          </ng-container>

          <!-- <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
            <td mat-cell *matCellDef="let element">{{element?.country?.country_name}}</td>
          </ng-container> -->

          <ng-container matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
            <td mat-cell *matCellDef="let element">{{element?.zone?.zone_name}}</td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
            <td mat-cell *matCellDef="let element">{{element?.state?.state_name}}</td>
          </ng-container>

          <ng-container matColumnDef="region">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
            <td mat-cell *matCellDef="let element">{{element?.region?.region_name}}</td>
          </ng-container>


          <ng-container matColumnDef="district">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>District</th>
            <td mat-cell *matCellDef="let element">{{element?.district?.district_name}}</td>
          </ng-container>

          <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Area</th>
            <td mat-cell *matCellDef="let element">{{element?.area?.area_name}}</td>
          </ng-container>

          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Of Termination</th>
            <td mat-cell *matCellDef="let element">{{element.msil_termination_date | date:'dd/MM/yyyy'}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="editData(element)">
              <img [src]="bucketurl + '/images/verified-profile.png'" class="edit-view"
                style="width: 30px; margin-left: 6px;" title="View" (click)="viewUserData(element)">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="12">No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit && !isParentDealerVerification">
      <div class="header-container">
        <h2>Parent Dealer</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="dealerForm">
        <div class="row">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Parent Dealer Name</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Parent Dealer Name" formControlName="dealerName"
                  maxlength="100" [ngClass]="{ 'is-invalid': submitted && f['dealerName'].errors }" />
                <div *ngIf="submitted && f['dealerName'].errors" class="invalid-feedback">
                  <div *ngIf="f['dealerName'].errors['required']">
                    Parent Dealer Name is required
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Parent Dealer Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Parent Dealer Code" formControlName="dealerCode"
                  maxlength="100" [ngClass]="{ 'is-invalid': submitted && f['dealerCode'].errors }" />
                <div *ngIf="submitted && f['dealerCode'].errors" class="invalid-feedback">
                  <div *ngIf="f['dealerCode'].errors['required']">
                    Parent Dealer Code is required
                  </div>
                </div>
              </div>
            </div>

            <!-- parent_map_code:"Parent Map Code",
            parent_location_code:"Parent Dealer Loc Code", -->

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Parent Map Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Parent Map Code"
                  formControlName="parent_dealer_map_code" maxlength="100"
                  [ngClass]="{ 'is-invalid': submitted && f['parent_dealer_map_code'].errors }" />
                <div *ngIf="submitted && f['parent_dealer_map_code'].errors" class="invalid-feedback">
                  <div *ngIf="f['parent_dealer_map_code'].errors['required']">
                    Parent Map Code is required
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Parent Dealer Loc Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Parent Dealer Loc Code"
                  formControlName="location_code" maxlength="100"
                  [ngClass]="{ 'is-invalid': submitted && f['location_code'].errors }" />
                <div *ngIf="submitted && f['location_code'].errors" class="invalid-feedback">
                  <div *ngIf="f['location_code'].errors['required']">
                    Parent Dealer Loc Code is required
                  </div>
                </div>
              </div>
            </div>


            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Country</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="country" (change)="getZoneList()"
                  [ngClass]="{ 'is-invalid': submitted && f['country'].errors }">
                  <option value="" disabled selected>--Select Country--</option>
                  <option [value]="data.id" *ngFor="let data of countryList">{{data.country_name}}</option>
                </select>
                <div *ngIf="submitted && f['country'].errors" class="invalid-feedback">
                  <div *ngIf="f['country'].errors['required']">Country is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Zone</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="zone" (change)="getStateList()"
                  [ngClass]="{ 'is-invalid': submitted && f['zone'].errors }">
                  <option value="" disabled selected>--Select Zone--</option>
                  <option [value]="data.id" *ngFor="let data of zoneList">{{data.zone_name}}</option>
                </select>
                <div *ngIf="submitted && f['zone'].errors" class="invalid-feedback">
                  <div *ngIf="f['zone'].errors['required']">Zone is required</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>State</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="state" (change)="getRegionList()"
                  [ngClass]="{ 'is-invalid': submitted && f['state'].errors }">
                  <option value="" disabled selected>--Select State--</option>
                  <option [value]="data.id" *ngFor="let data of stateList">{{data.state_name}}</option>
                </select>
                <div *ngIf="submitted && f['state'].errors" class="invalid-feedback">
                  <div *ngIf="f['state'].errors['required']">State is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Region</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="region" (change)="getDistrictList()"
                  [ngClass]="{ 'is-invalid': submitted && f['region'].errors }">
                  <option value="" disabled selected>--Select Region--</option>
                  <option [value]="data.id" *ngFor="let data of regionList">{{data.region_name}}</option>
                </select>
                <div *ngIf="submitted && f['region'].errors" class="invalid-feedback">
                  <div *ngIf="f['region'].errors['required']">Region is required</div>
                </div>
              </div>
            </div>
          </div>



          <div class="row mt-3">

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>District</label>
                <select name="" class="form-select" formControlName="district" (change)="getAreaList()"
                  [ngClass]="{ 'is-invalid': submitted && f['district'].errors }">
                  <option value="" disabled selected>--Select District--</option>
                  <option [value]="data.id" *ngFor="let data of districtList">{{data.district_name}}</option>
                </select>
                <div *ngIf="submitted && f['district'].errors" class="invalid-feedback">
                  <div *ngIf="f['district'].errors['required']">District is required</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Area</label>
                <select name="" class="form-select" formControlName="area" (change)="getLocationList()"
                  [ngClass]="{ 'is-invalid': submitted && f['area'].errors }">
                  <option value="" disabled selected>--Select Area--</option>
                  <option [value]="data.id" *ngFor="let data of areaList">{{data.area_name}}</option>
                </select>
                <div *ngIf="submitted && f['area'].errors" class="invalid-feedback">
                  <div *ngIf="f['area'].errors['required']">Area is required</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Location</label>
                <select name="" class="form-select" formControlName="location"
                  [ngClass]="{ 'is-invalid': submitted && f['location'].errors }">
                  <option value="" disabled selected>--Select Location--</option>
                  <option [value]="data.id" *ngFor="let data of locationList">{{data.location_name}}</option>
                </select>
                <div *ngIf="submitted && f['location'].errors" class="invalid-feedback">
                  <div *ngIf="f['location'].errors['required']">Location is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="status"
                  [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                  <option value="" disabled selected>--Select Status--</option>
                  <option value="1">Active</option>
                  <option value="0">In-Active</option>
                </select>
                <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
                  <div *ngIf="f['status'].errors['required']">Status is required</div>
                </div>
              </div>
            </div>
          </div>


          <div class="row mt-3">
            <div class="col-12 mt-3">
              <div class="form-check mt-3">
                <input type="checkbox" class="form-check-input large-checkbox" id="is_verified"
                  formControlName="is_verified" style="border: 1px solid #030303; ">

                <label class="form-check-label" for="is_verified" style="color: #333;">
                  I confirm that I have checked and verified the Parent Dealer information.
                </label>
              </div>
            </div>
          </div>

          <!-- <div class="row mt-3">
            
          </div> -->

          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button *ngIf="isCreate" mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
              <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button (click)="create()">Create</button>
              <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button (click)="update()">Update</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="isParentDealerVerification">
      <div class="header-container">
        <h2>Parent Dealer Verified By</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">
            Back to List
          </button>
        </div>
      </div>

      <div class="leads-table mb-3">
        <table mat-table [dataSource]="verificationDataSource" matSort class="mat-table">

          <!-- S.No -->
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef>S.No</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ (verificationPaginator.pageIndex * verificationPaginator.pageSize) + (i + 1) }}
            </td>
          </ng-container>


          <!-- Outlet Name -->
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Username
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.username }}
            </td>
          </ng-container>

          <!-- Outlet Code -->
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Verified Date
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt }}
            </td>
          </ng-container>

          <!-- Outlet For Code -->
          <!-- <ng-container matColumnDef="outlet_for_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Outlet For Code
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.outlet_for_code }}
            </td>
          </ng-container>

           <!-- IP Adress -->
          <ng-container matColumnDef="ip_address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              IP Address
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.ip_address }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="verificationDisplayedColumns; sticky: true">
          </tr>

          <tr mat-row *matRowDef="let row; columns: verificationDisplayedColumns;">
          </tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center p-3" colspan="5">
              No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #verificationPaginator [pageSizeOptions]="[10, 20]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </ng-container>
  </div>
</div>